import './CSS/downloadButtonStyle.css';
function ResumeButton(props) {
    return (
        
        <a href="https://docs.google.com/document/d/1Z6E8bcwZZFc4WV2V-8XqshTnVuXPBXkPyYk3g54UAIg/edit?usp=sharing" target="_blank"><button class="btn"><i class="fa fa-download"></i> Download CV</button></a> 
    );
  }
  
  export default ResumeButton;
  